module.exports = __webpack_public_path__ + "static/media/ExlyManageFeedbackForms_preview.a3359210.png";